import { render, staticRenderFns } from "./OrderView.vue?vue&type=template&id=094b6918&scoped=true&"
import script from "./OrderView.vue?vue&type=script&lang=js&"
export * from "./OrderView.vue?vue&type=script&lang=js&"
import style0 from "./OrderView.vue?vue&type=style&index=0&id=094b6918&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094b6918",
  null
  
)

export default component.exports